<template>
  <div class="card">
    <nuxt-link :to="`stories/${member.url}`">
      <div class="card-image">
        <img
          v-if="memberImage"
          :src="memberImage"
          alt="user"
        />
        <NuxtPicture
          v-else
          src="/images/journal/article/main.png"
          alt="user"
        />
      </div>
      <div class="card-content">
        <div class="card-info">
          <div class="name-wrapper">
            <p class="name">{{ member.name }}</p>
            <NuxtImg
              v-if="countryImage"
              :src="countryImage"
              :alt="`${countryImage} flag`"
              class="flag"
            />
          </div>
          <p class="role">{{ member.position }}</p>
          <p
            v-if="member.joined_at"
            class="experience"
          >
            {{ member.joined_at }}
          </p>
          <p class="description">{{ member.summary }}</p>
        </div>
        <ReadMore />
      </div>
    </nuxt-link>
  </div>
</template>

<script>
import ReadMore from '~/components/Common/ReadMore/ReadMore.vue';
import cloudinaryImage from '~/utils/helpers/cloudinaryImage';

export default {
  components: { ReadMore },
  props: {
    member: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    memberImage() {
      return this.member.list_image
        ? cloudinaryImage({ imagePath: this.member.list_image, width: 400 })
        : null;
    },
    countryImage() {
      return this.member?.member_country
        ? `/images/icons/flags/${this.member?.member_country}.svg`
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './MemberStoryCard.scss';
</style>
